import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import AppBar from "@mui/material/AppBar";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper/Paper";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography/Typography";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getNotification, getall } from "../../actions/notification";
import { resetUsers } from "../../actions/user";
import DeletePopUp from "../../components/DeletePopup";
import TabPanel from "../../components/TabPanel";
import {
  GetProgressStatus,
  getTypeColor,
} from "../../shared-functions/notification";
import { Theme247 } from "../../styles/Theme247";
import { ApplyStyle as _s } from "../../utils/ApplyStyle";
import Cost from "./_tabs/Cost/costs";
import Overview from "./_tabs/Overview/OverviewTab";
import MoreVertRoundedIcon from "@mui/icons-material/MoreVertRounded";

import { Send } from "@mui/icons-material";
import TimelapseIcon from "@mui/icons-material/Timelapse";
import { ReactComponent as TerminSvg } from "../../assets/terminSvg.svg";
import { ReactComponent as RotationSvg } from "../../assets/rotationSvg.svg";
import { ReactComponent as CheckSvg } from "../../assets/checkSvg.svg";

import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Skeleton,
  Snackbar,
  TextField,
  Zoom,
} from "@mui/material";
import clsx from "clsx";
import InformationOutlineIcon from "mdi-react/InformationOutlineIcon";

import { useDispatch } from "react-redux";
import { ShareNotification } from "../../actions/notification";
import IconText from "../../components/IconText";
import TypeBadge from "../../components/TypeBadge";
import store from "../../store";
import {
  NotificationType,
  StatusType,
  getNotificationTooltipAndColor,
} from "../../types";
import { GetTitleSafely, truncateWithEllipses } from "../../utils/helpers";
import { ReactComponent as RoundedEditSvg } from "../../assets/roundedEdit.svg";
import { ReactComponent as RoundedDeleteSvg } from "../../assets/roundedDelete.svg";
import Solutions from "./_tabs/Solutions/Solutions";
import moment from "moment";

import { DeleteNotification } from "../../actions/notification";
import { canUserPerformAction } from "../../shared-functions/userrights";
import NewProtocol from "../protocol/NewProtocol";
import Costs from "./_tabs/Cost/costs";
import { setItem } from "../../utils/DataProtection";
import { getUnits } from "../../actions/counters";
// import { getUnits } from "../../shared-functions/units";

var time = require("time-since");
var doOnce = true;

const getNotificationTagLabel = (tag) => {
  if (typeof tag === "string") return tag;
  if (Array.isArray(tag)) {
    const labelPart = tag?.[2];
    if (typeof labelPart === "string") return labelPart;
    if (labelPart && typeof labelPart === "object") {
      if (typeof labelPart?.de === "string") return labelPart.de;
      if (typeof labelPart?.de?.label === "string") return labelPart.de.label;
      if (typeof labelPart?.label === "string") return labelPart.label;
    }
    return "";
  }
  if (tag && typeof tag === "object") {
    if (typeof tag?.de === "string") return tag.de;
    if (typeof tag?.de?.label === "string") return tag.de.label;
    if (typeof tag?.label === "string") return tag.label;
    if (typeof tag?.tag_label === "string") return tag.tag_label;
    if (typeof tag?.tag_laebl === "string") return tag.tag_laebl;
  }
  return "";
};

const getNotificationTagLabels = (notification) => {
  const tags = notification?.tags;
  if (!Array.isArray(tags)) return [];
  return [...new Set(tags.map(getNotificationTagLabel).filter(Boolean))];
};

export default connect(
  ({
    data,
    emailSent,
    i18n,
    notification,
    userProfile,
    profile,
    userType,
    machines,
    units,
  }) => ({
    data,
    emailSent,
    i18n,
    userProfile,
    profile,
    notification,
    userType,
    machines,
    units,
  }),
  {
    getall,
    getNotification,
    resetUsers,
    ShareNotification,
    DeleteNotification,
    getUnits,
  }
)((props) => {
  const i18n = props.i18n;

  const url = new URL(window.location.href);
  const { units } = props;
  function getCounterUnit(data, units) {
    // Extract the counter node ID from hasmaintenancetask -> triggeringevent[0]
    const counterNodeId =
      data.hasmaintenancetask?.[0]?.maintenancetask?.triggeringevent?.[0];

    if (!counterNodeId) {
      console.error("No counter node ID found in triggering event.");
      return null;
    }

    // Find the counter object in isnotificationof
    const counters = data.isnotificationof?.[0]?.equipment?.hascounter || [];
    const counter = counters.find((c) => c.counter.nodeid === counterNodeId);

    if (!counter) {
      console.error("No matching counter found.");
      return null;
    }

    // Extract the unitId from hascountertype

    const unitId =
      counter.counter.hascountertype?.[0]?.countertype?.unit?.unitid !==
      undefined
        ? counter.counter.hascountertype?.[0]?.countertype?.unit?.unitid
        : counter.counter.hascountertype?.[0]?.countertype?.unit?.unit?.unitId;

    if (!unitId) {
      console.error("No unit ID found for the counter.");
      return null;
    }

    // Find the unit details from units array
    const unit = units.find((u) => u.unitId === unitId);

    return unit ? unit.displayName.plural[store.getState()?.language] : "";
  }

  const dispatch = useDispatch();
  let location = useLocation();

  const params = new URLSearchParams(location.search);
  const tab = params.get("tab");

  const nodeid = location.state && location.state.nodeid;
  const equipmentNodeId = location.state && location.state.equipmentNodeId;
  const from = location.state && location.state.from;

  var notification = props.notification;
  const notificationTagLabels = getNotificationTagLabels(
    props?.notification?.notification
  );

  // //console.log( notification.type)

  const isnotificationof =
    props.notification.notification &&
    props.notification.notification.isnotificationof &&
    props.notification.notification.isnotificationof[0]?.equipment.name.de;

  // const NotificationType = {
  //   0: i18n.notificationtype_malfunction,
  //   1: i18n.notificationtype_abnormality,
  //   2: i18n.notificationtype_memo,
  //   3: i18n.notificationtype_task,
  //   4: i18n.notificationtype_internal_message,
  //   5: i18n.notificationtype_manufacturer_message,
  //   6: i18n.notificationtype_planned_maintenance
  // };

  useEffect(() => {
    setItem("chatroomnodeid", "0");
    return () => {
      // dispatch({ type: 'CLEARNOTIFICATION', payload: {} });
    };
  }, []);

  useEffect(() => {
    setActiveTab(tab !== null ? +tab : 0);
  }, [window.location]);

  // Object.freeze(NotificationType);

  const [activeTab, setActiveTab] = React.useState(+tab);
  const [alertText, setAlertText] = React.useState("");
  const [alertType, setAlertType] = React.useState("");

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
    setProtokolEditView(false);
  };

  const cardStyle = generateCardStyle(props.notification?.notification?.type);

  function generateCardStyle(typecode) {
    if (typecode !== null) {
      let text = NotificationType(Number(typecode));

      return { status: getTypeColor(typecode, "card")?.class, text: text };
    } else {
      return {
        status: getTypeColor(undefined, "card"),
        text: "Undefined card typecode.",
      };
    }
  }

  const [isShare, setIsShare] = useState(false);
  const [openDialogDelete, setopenDialogDelete] = useState(false);
  const [email, setEmail] = useState("");
  const handleShareOpen = () => {
    setIsShare(true);
  };

  const handleShareClose = () => {
    setIsShare(false);
  };

  const handleShareInputChange = (event) => {
    setEmail(event.target.value);
  };

  const handleDialogDelete = () => {
    setopenDialogDelete(false);
  };

  const handleShareSubmit = () => {
    if (email.length === 0 || !email.includes("@") || !email.includes(".")) {
      setAlertText("Please enter valid email address");
      setAlertType("error");
      return;
    }
    props.ShareNotification(
      {
        nodeid: notification?.notification?.nodeid,
        receiver: email,
        name:
          props?.userProfile?.user?.givenname +
          " " +
          props?.userProfile?.user?.surname,
      },
      "ShareNotification"
    );
    setEmail("");
    setIsShare(false);
    setAlertType("success");
    setAlertText("Email sent!");
    // setstateSnack({ openSnack: true, vertical: 'top', horizontal: 'center', text: "Email Sent Successfully!" });
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch({
      type: "EMAIL_SENT",
      payload: false,
    });
  };

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMore = () => {
    setAnchorEl(null);
  };

  const getDateFromTimestamp = (unixTimeStamp) => {
    let date = new Date(unixTimeStamp);
    return (
      date.getFullYear() +
      "-" +
      (date.getMonth() + 1 <= 9
        ? "0" + (date.getMonth() + 1)
        : date.getMonth() + 1) +
      "-" +
      (date.getDate() <= 9 ? "0" + date.getDate() : date.getDate())
    );
  };
  const getTimeFromTimestamp = (unixTimeStamp) => {
    let date = new Date(unixTimeStamp);
    return (
      date.getHours() +
      ":" +
      (date.getMinutes() <= 9 ? "0" + date.getMinutes() : date.getMinutes())
    );
  };

  const equp_local =
    notification?.notification?.isnotificationof &&
    notification?.notification?.isnotificationof[0]?.equipment;
  const equq_pool_local =
    notification?.notification?.isnotificationof &&
    notification?.notification?.isnotificationof[0]?.equipment?.isequipmentof[0]
      ?.equipmentpool != undefined
      ? notification?.notification?.isnotificationof &&
        notification?.notification?.isnotificationof[0]?.equipment
          ?.isequipmentof[0]?.equipmentpool
      : notification?.notification?.isnotificationof &&
        notification?.notification?.isnotificationof[0]?.equipment
          ?.isequipmentof[0]?.area;

  const creation_date = getDateFromTimestamp(
    notification?.notification?.created
  );
  const creation_time = getTimeFromTimestamp(
    notification?.notification?.created
  );

  /*
   * Styles
   */

  const notiType = props?.notification?.notification?.type;

  const navigate = useNavigate();

  const handleDeleteNotification = () => {
    handleCloseMore();
    setopenDialogDelete(true);
  };

  const handleDelete = async () => {
    setopenDialogDelete(false);
    const nodeid = props.notification.notification.nodeid;
    await props.DeleteNotification({ nodeid });
    setTimeout(() => {
      navigate(
        from == "history"
          ? "/machine-overview?nodeid=" +
              encodeURIComponent(equipmentNodeId) +
              "&tab=1"
          : from == "overview"
          ? "/machine-overview?nodeid=" +
            encodeURIComponent(equipmentNodeId) +
            "&tab=0"
          : from == "Maintenance"
          ? "/machine-overview?nodeid=" +
            encodeURIComponent(equipmentNodeId) +
            "&tab=4"
          : from === "maintenance_dashboard"
          ? "/maintenance-dashboard"
          : "/notifications-dashboard"
      );
    }, 3000);
  };

  var executed_date = "";
  var executed_time = "";
  if (notification?.notification?.hasreport != undefined) {
    executed_date = getDateFromTimestamp(
      moment(notification.notification.hasreport[0].report.executed)
    );
    executed_time = getTimeFromTimestamp(
      moment(notification.notification.hasreport[0].report.executed)
    );
  }

  const [protokolEditView, setProtokolEditView] = useState(false);
  const notificationEquipmentNodeId =
    props?.notification?.notification?.isnotificationof?.[0]?.equipment?.nodeid;
  const equipmentOverviewLink = notificationEquipmentNodeId
    ? "/machine-overview?nodeid=" +
      encodeURIComponent(notificationEquipmentNodeId)
    : "";

  useEffect(() => {
    if (units.length === 0) {
      props.getUnits("UNITS");
    }
  }, []);


  const getIconText = (notification) => {
    const task = notification?.hasmaintenancetask?.[0]?.maintenancetask;
    if (!task) return "";
  
    const intervalMap = {
      "1m": " monatlich",
      "2m": " 2 monate",
      "2w": " 2 wochen",
      "6w": " 6 wochen",
      "1w": " 1 woche",
      "onetime": " einmalig",
      "3m": " quartalsweise",
      "6m": " 6 monate",
      "12m": " 12 monate",
      "1y": " jährlich",
      "18m": " 18 monate",
      "36m": " 36 monate",
      "48m": " 48 monate",
    };
  
    const intervalText = intervalMap[task.repetitioninterval] ?? "";
  
    const counterText =
      task.triggertype === "counter"
        ? ` / ${(task.triggeringevent?.[1] ?? "")} ${getCounterUnit(notification, units) ?? ""}`.trim()
        : "";
  
    return intervalText + counterText;
  };
  

  return notification != undefined ? (
    <>
      <Dialog
        sx={{ backdropFilter: "blur(4px)" }}
        TransitionComponent={Zoom}
        open={isShare}
        onClose={handleShareClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        className="share-notification-dialog"
      >
        <DialogTitle id="alert-dialog-title">{"Meldung teilen"}</DialogTitle>
        <DialogContent id="alert-dialog-description">
          Bitte geben Sie den Email-Empfänger ein
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            flexDirection: "column",
            padding: "0px 22px 22px 22px",
          }}
        >
          <TextField
            variant="outlined"
            label="Email"
            type="email"
            sx={{ width: "100% " }}
            onChange={handleShareInputChange}
            value={email}
            required
          />
          <Button
            className="bxShadow"
            sx={{
              width: "100% ",
              marginTop: "10px",
              marginLeft: "0px !important",
            }}
            variant="outlined"
            startIcon={<Send />}
            onClick={handleShareSubmit}
          >
            Senden
          </Button>
        </DialogActions>
      </Dialog>

      <Breadcrumbs aria-label="breadcrumb" className={_s(Theme247.breadcrumbs)}>
        <Link
          to={
            from == "aufgabenplanung" ? "/aufgabeplanung" :
            from == "history"
              ? "/machine-overview?nodeid=" +
                encodeURIComponent(equipmentNodeId) +
                "&tab=1"
              : from == "overview"
              ? "/machine-overview?nodeid=" +
                encodeURIComponent(equipmentNodeId) +
                "&tab=0"
              : from == "Maintenance"
              ? "/machine-overview?nodeid=" +
                encodeURIComponent(equipmentNodeId) +
                "&tab=4"
              : from === "maintenance_dashboard"
              ? "/maintenance-dashboard"
              : "/notifications-dashboard"
          }
        >
          <ArrowBackIcon size="large" />

          { from == "aufgabenplanung" ? "Aufgabenplanung" : from == "machine"
            ? isnotificationof
            : from == "history"
            ? "History" 
             : from == "overview"
            ? "Overview"
            : from == "Maintenance"
            ? "Maintenance"
            : from === "maintenance_dashboard"
            ? "Geplant Wartung"
            : i18n.opennotifications}
        </Link>
      </Breadcrumbs>

      <section style={{ marginBottom: "40%" }}>
        <Paper
          elevation={Theme247.elevationLow}
          className={_s(Theme247.sectionContainer)}
        >
          <Grid
            container
            spacing={3}
            direction="row"
            alignItems="center"
            className={clsx("ND_HeaderCard")}
            style={{
              borderTopColor:
                notiType === 6
                  ? "#039BE5"
                  : getNotificationTooltipAndColor(
                      props.notification?.notification?.type
                    )?.color,
            }}
          >
            <Grid item xs={8}>
              {/* {notification.notification.type == 6 ? (
                      <Typography variant="h1" color="inherit">
                        {notification.notification.title}<br />
                        <span className={_s(Theme247.typography.regular)}>{i18n.maintenance_next_termine + ': ' + moment(notification.notification.created).format('DD.MM.YYYY')}</span>
                      </Typography>
                    ) : (
                      <Typography variant="h1" color="inherit">
                        {GetNotificationTypeDate(notification)}<br />
                        <span className={_s(Theme247.typography.regular)}>{GetNotificationTime(notification)}</span>
                      </Typography>
                    )} */}

              <Typography
                className={clsx("title","ellipsis")}
                title={GetTitleSafely(props?.notification?.notification)}
              >
                {
                  GetTitleSafely(props?.notification?.notification)}
              </Typography>

              {props?.notification?.notification?.isnotificationof?.length >
              0 ? (
                <span className={"subTitle"}>
                  {equipmentOverviewLink ? (
                    <Link
                      to={equipmentOverviewLink}
                      style={{
                        color: "inherit",
                        textDecoration: "none"
                      }}
                    >
                      {props?.notification?.notification?.isnotificationof[0]
                        ?.equipment?.hasequipmenttype[0]?.equipmenttype
                        ?.isequipmenttypeof != undefined
                        ? props?.notification?.notification?.isnotificationof[0]
                            ?.equipment?.hasequipmenttype[0]?.equipmenttype
                            ?.isequipmenttypeof[0]?.brand?.name
                        : ""}
                      {"  •  "}
                      {
                        props?.notification?.notification?.isnotificationof[0]
                          ?.equipment?.hasequipmenttype[0]?.equipmenttype?.model
                      }
                      {"  •  "}
                      {
                        props?.notification?.notification?.isnotificationof[0]
                          ?.equipment?.name[store.getState()?.language]
                      }
                      {"  •  "}
                      {
                        props?.notification?.notification?.isnotificationof[0]
                          ?.equipment?.isequipmentof[0]?.equipmentpool?.name[
                          store.getState().language
                        ]
                      }
                    </Link>
                  ) : (
                    <>
                      {props?.notification?.notification?.isnotificationof[0]
                        ?.equipment?.hasequipmenttype[0]?.equipmenttype
                        ?.isequipmenttypeof != undefined
                        ? props?.notification?.notification?.isnotificationof[0]
                            ?.equipment?.hasequipmenttype[0]?.equipmenttype
                            ?.isequipmenttypeof[0]?.brand?.name
                        : ""}
                      {"  •  "}
                      {
                        props?.notification?.notification?.isnotificationof[0]
                          ?.equipment?.hasequipmenttype[0]?.equipmenttype?.model
                      }
                      {"  •  "}
                      {
                        props?.notification?.notification?.isnotificationof[0]
                          ?.equipment?.name[store.getState()?.language]
                      }
                      {"  •  "}
                      {
                        props?.notification?.notification?.isnotificationof[0]
                          ?.equipment?.isequipmentof[0]?.equipmentpool?.name[
                          store.getState().language
                        ]
                      }
                    </>
                  )}
                  <br />
                </span>
              ) : (
                ""
              )}

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: "15px",
                }}
              >
                <div>
                  <TypeBadge
                    typecode={props?.notification?.notification?.type}
                    notification={props?.notification?.notification}
                    oncard
                    showPriorityIcon
                    style={{ marginLeft: "0px" }}
                  />
                </div>
                <div style={{ margin: "0px 10px" }}>
                  <svg
                    width="2"
                    height="12"
                    viewBox="0 0 2 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      opacity="0.35"
                      d="M1.22168 0.046875V11.8457H0.203125V0.046875H1.22168Z"
                      fill="#9E9E9E"
                    />
                  </svg>
                </div>
                {notificationTagLabels.length ? (
                  <>
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        flexWrap: "wrap",
                      }}
                    >
                      {notificationTagLabels.map((tagLabel) => (
                        <span
                          key={tagLabel}
                          style={{
                            display: "inline-flex",
                            alignItems: "center",
                            minHeight: 24,
                            border: "1px solid rgba(0, 0, 0, 0.36)",
                            borderRadius: 16,
                            padding: "2px 12px",
                            color: "rgba(0, 0, 0, 0.87)",
                            fontSize: 34 / 3,
                            lineHeight: 1.2,
                            backgroundColor: "transparent",
                          }}
                        >
                          {tagLabel}
                        </span>
                      ))}
                    </div>
                    <div style={{ margin: "0px 10px" }}>
                      <svg
                        width="2"
                        height="12"
                        viewBox="0 0 2 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.35"
                          d="M1.22168 0.046875V11.8457H0.203125V0.046875H1.22168Z"
                          fill="#9E9E9E"
                        />
                      </svg>
                    </div>
                  </>
                ) : null}
                <div
                  className={_s(Theme247.itemcard.iconTextInline)}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  {notiType === 6 ? (
                    <IconText
                      style={{ margin: 0 }}
                      icon={<TerminSvg />}
                      text={
                        props.i18n.due_on +
                        ": " +
                        moment(
                          props.notification.notification.dueuntil === 0
                            ? props.notification.notification.created
                            : props.notification.notification.dueuntil
                        ).format("DD.MM.YYYY")
                      }
                    />
                  ) : (
                    <>
                      <IconText
                        style={{ margin: 0 }}
                        icon={<InformationOutlineIcon />}
                        text={
                          "Status: " +
                          StatusType(props?.notification?.notification?.status)
                        }
                      />

                      {notification?.notification?.hasworkflow?.length && (
                        <>
                          <div style={{ margin: "0px 10px" }}>
                            <svg
                              width="2"
                              height="12"
                              viewBox="0 0 2 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                opacity="0.35"
                                d="M1.22168 0.046875V11.8457H0.203125V0.046875H1.22168Z"
                                fill="#9E9E9E"
                              />
                            </svg>
                          </div>
                          <IconText
                            className="primarySolution"
                            style={{ margin: 0 }}
                            icon={<CheckSvg />}
                            text={"Maßnahme hinterlegt"}
                          />
                        </>
                      )}
                    </>
                  )}
                  {/* Show Hours Unresolved for status 0, 1 */}

                  {/* <div style={{ margin: "0px 10px" }}>
                      <svg
                        width="2"
                        height="12"
                        viewBox="0 0 2 12"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          opacity="0.35"
                          d="M1.22168 0.046875V11.8457H0.203125V0.046875H1.22168Z"
                          fill="#9E9E9E"
                        />
                      </svg>
                    </div> */}

                  {notiType === 6 &&
                  props.notification?.notification?.hasmaintenancetask &&
                  props.notification?.notification?.hasmaintenancetask[0]
                    .maintenancetask?.repetitioninterval !== "" ? (
                    <>
                      {props.notification.notification?.hasmaintenancetask && (
                        <>
                          <div style={{ margin: "0px 10px" }}>
                            <svg
                              width="2"
                              height="12"
                              viewBox="0 0 2 12"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                opacity="0.35"
                                d="M1.22168 0.046875V11.8457H0.203125V0.046875H1.22168Z"
                                fill="#9E9E9E"
                              />
                            </svg>
                          </div>

                          <IconText
                            icon={<RotationSvg />}
                            text={
                           getIconText(props.notification.notification)
                            }
                          />
                        </>
                      )}
                    </>
                  ) : notiType !== 6 &&
                    props?.notification?.notification?.status < 2 ? (
                    <>
                      <div style={{ margin: "0px 10px" }}>
                        <svg
                          width="2"
                          height="12"
                          viewBox="0 0 2 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.35"
                            d="M1.22168 0.046875V11.8457H0.203125V0.046875H1.22168Z"
                            fill="#9E9E9E"
                          />
                        </svg>
                      </div>
                      <IconText
                        icon={<CheckSvg />}
                        text={GetProgressStatus(
                          props?.notification?.notification
                        )}
                      />
                    </>
                  ) : (
                    false
                  )}
                  {notiType === 6 &&
                  props?.notification?.notification.hasmaintenancetask &&
                  props?.notification?.notification.hasmaintenancetask[0]
                    .maintenancetask.repetitioninterval !== "" ? (
                    <>
                    {
                      props.notification.notification
                      .hasmaintenancetask[0].maintenancetask.nextdueat <= 0 ? "" :
                    <>
                      <div style={{ margin: "0px 10px" }}>
                        <svg
                          width="2"
                          height="12"
                          viewBox="0 0 2 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            opacity="0.35"
                            d="M1.22168 0.046875V11.8457H0.203125V0.046875H1.22168Z"
                            fill="#9E9E9E"
                          />
                        </svg>
                      </div>
                   
                      
                        <IconText
                          style={{ margin: 0 }}
                          icon={<TerminSvg />}
                          text={
                            props.i18n.next_appointment +
                            ": " + 
                            moment(
                              props.notification.notification
                                .hasmaintenancetask[0].maintenancetask.nextdueat
                            ).format("DD.MM.YYYY")
                          }
                        />
                        </>
                        }
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
            </Grid>

            <Grid
              item
              xs={4}
              style={{ display: "flex", justifyContent: "end" }}
            >
              <div className="preMailButton" onClick={handleShareOpen}>
                <div className="icon">
                  <svg
                    width="18"
                    height="18"
                    viewBox="0 0 18 18"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_3138_11060)">
                      <mask
                        id="mask0_3138_11060"
                        style={{ maskType: "alpha" }}
                        maskUnits="userSpaceOnUse"
                        x="0"
                        y="0"
                        width="24"
                        height="24"
                      >
                        <rect width="24" height="24" fill="#D9D9D9" />
                      </mask>
                      <g mask="url(#mask0_3138_11060)">
                        <path
                          d="M3.3 14.5692C3.05 14.6692 2.8125 14.6472 2.5875 14.5032C2.3625 14.3597 2.25 14.1505 2.25 13.8755V11.0817C2.25 10.9067 2.3 10.7505 2.4 10.613C2.5 10.4755 2.6375 10.388 2.8125 10.3505L8.25 9.00047L2.8125 7.65047C2.6375 7.61297 2.5 7.52547 2.4 7.38797C2.3 7.25047 2.25 7.09422 2.25 6.91922V4.12547C2.25 3.85047 2.3625 3.64097 2.5875 3.49697C2.8125 3.35347 3.05 3.33172 3.3 3.43172L14.85 8.30672C15.1625 8.44422 15.3187 8.67547 15.3187 9.00047C15.3187 9.32547 15.1625 9.55672 14.85 9.69422L3.3 14.5692Z"
                          fill="#0E3F51"
                        />
                      </g>
                    </g>
                    <defs>
                      <clipPath id="clip0_3138_11060">
                        <rect width="18" height="18" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>
                <div className="text">per e-mail teilen</div>
              </div>

              <div style={{ margin: "-3px 0px 5px 24px" }}>
                <IconButton
                  aria-label="more"
                  id="long-button"
                  aria-controls={open ? "long-menu" : undefined}
                  aria-expanded={open ? "true" : undefined}
                  aria-haspopup="true"
                  onClick={handleClick}
                >
                  <MoreVertRoundedIcon />
                </IconButton>
                <Menu
                  id="long-menu"
                  MenuListProps={{
                    "aria-labelledby": "long-button",
                  }}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleCloseMore}
                  className="moreActions"
                >
                  <MenuItem id="1" onClick={handleCloseMore}>
                    <Link
                      to="/edit-notification"
                      state={{
                        notification: notification?.notification,
                        equip: equp_local,
                        equip_pool: equq_pool_local,
                        date: creation_date,
                        time: creation_time,
                        pageType: "edit",
                        from: "notification",
                      }}
                    >
                      <div className="menuItem">
                        <div className="icon">
                          <RoundedEditSvg />
                        </div>
                        <div className="text"> {i18n.edit_notification}</div>
                      </div>
                    </Link>
                  </MenuItem>

                  {canUserPerformAction(
                    props.profile?.features?.notification,
                    "delete"
                  ) ? (
                    <>
                      <Divider orientation="horizontal" style={{ margin: 0 }} />
                      <MenuItem id="1" onClick={handleDeleteNotification}>
                        <div className="menuItem">
                          <div className="icon">
                            <RoundedDeleteSvg />
                          </div>
                          <div className="text">Meldung löschen</div>
                        </div>
                      </MenuItem>
                    </>
                  ) : (
                    ""
                  )}
                </Menu>
                <DeletePopUp
                  open={openDialogDelete}
                  handleClose={handleDialogDelete}
                  handleDelete={handleDelete}
                  topic="Notification"
                ></DeletePopUp>
              </div>
            </Grid>
          </Grid>

          <Grid
            container
            spacing={3}
            direction="row"
            className={_s(Theme247.tabsContainer)}
          >
            <Grid item xs={12}>
              <AppBar position="static">
                <Tabs value={activeTab} onChange={handleTabChange}>
                  <Tab
                    label={i18n.tab_overview}
                    sx={{ color: "inherit", letterSpacing: 1 }}
                    style={{ width: "14%" }}
                  />
                  <Tab
                    label={
                      props.notification?.notification?.type === 6
                        ? "REPORT"
                        : "AUFWANDSERFASSUNG"
                    }
                    sx={{ color: "inherit", letterSpacing: 1 }}
                  />
                  {props.notification?.notification?.type !== 6 ? (
                    <Tab label={"Maßnahme"} sx={{ color: "inherit", letterSpacing: 1 }} />
                  ) : (
                    ""
                  )}
                </Tabs>
              </AppBar>
              <TabPanel value={activeTab} index={0}>
                <Overview
                  setActiveTab={setActiveTab}
                  setProtokolEditView={setProtokolEditView}
                />
              </TabPanel>
              <TabPanel value={activeTab} index={1}>
                {props?.notification?.notification?.type === 6 &&
                protokolEditView ? (
                  <NewProtocol
                    executed={
                      props.notification?.notification?.hasreport &&
                      props.notification?.notification?.hasreport[0]?.report
                        .executed
                    }
                    nextdueat={props.notification.notification
                      .hasmaintenancetask[0].maintenancetask.nextdueat}
                    created={
                      props.notification?.notification?.hasreport &&
                      props.notification?.notification?.hasreport[0]?.report
                        .created
                    }
                    costs={props.notification?.notification?.hascost}
                    auther={
                      props.notification?.notification?.hasreport &&
                      props.notification?.notification?.hasreport[0]?.report
                        ?.hasauthor &&
                      props.notification?.notification?.hasreport &&
                      props.notification?.notification?.hasreport[0]?.report
                        ?.hasauthor[0]?.user?.givenname +
                        " " +
                        props.notification?.notification?.hasreport &&
                      props.notification?.notification?.hasreport[0]?.report
                        ?.hasauthor &&
                      props.notification?.notification?.hasreport &&
                      props.notification?.notification?.hasreport[0]?.report
                        ?.hasauthor[0]?.user?.surname
                    }
                    attachments={
                      props.notification?.notification?.hasreport &&
                      props.notification?.notification?.hasreport[0]?.report
                        .hasattachment
                    }
                    reportnodeid={
                      props.notification?.notification?.hasreport &&
                      props.notification?.notification?.hasreport[0]?.report
                        .nodeid
                    }
                    date={executed_date}
                    time={executed_time}
                    comment={
                      props.notification?.notification?.hasreport &&
                      props.notification?.notification?.hasreport[0]?.report
                        .comment
                    }
                    notificationnodeid={
                      props.notification?.notification?.nodeid
                    }
                    attachmentsOf={"report"}
                    pageType={
                      props.notification?.notification?.hasreport
                        ? "edit"
                        : "add"
                    }
                    authorsignature={
                      props.notification?.notification?.hasreport &&
                      props.notification?.notification?.hasreport[0]?.report
                        .authorsignature
                    }
                    equipmentNodeId={equipmentNodeId}
                    equipmentcurrency={props.machines?.equipment?.equipmentcurrency}
                    setProtokolEditView={setProtokolEditView}
                  />
                ) : (
                  <Costs setProtokolEditView={setProtokolEditView} />
                )}
              </TabPanel>
              <TabPanel value={activeTab} index={2}>
                <Solutions />
              </TabPanel>
            </Grid>
          </Grid>
        </Paper>

        <Snackbar
          anchorOrigin={{ vertical: "top", horizontal: "right" }}
          open={props.emailSent}
          autoHideDuration={4000}
          onClose={handleClose}
          TransitionComponent={Zoom}
        >
          <Alert
            severity={alertType}
            sx={{ width: "100%" }}
            className="bxShadow"
          >
            {alertText}
          </Alert>
        </Snackbar>
      </section>
    </>
  ) : (
    <div>
      {" "}
      <Skeleton
        variant="rounded"
        width={921}
        animation="wave"
        height={139}
      />{" "}
      <br />
      <br />{" "}
      <Skeleton
        variant="rounded"
        animation="wave"
        width={921}
        height={650}
      />{" "}
    </div>
  );
});
